import(/* webpackMode: "eager", webpackExports: ["SearchProvider"] */ "/vercel/path0/src/app/providers/SearchProvider/index.tsx");
